export default {
  formFields: {
    fieldHelp: 'Kliknutím otevřete popis',
    defaultAbbreviation: 'df.: ',
    paramJSONContent: 'JSON obsah',
    wrongInputValue: 'Špatná vstupní hodnota tohoto parametru.',
    notValidJsonString: 'Žádný platný Json pro :fieldName'
  }
}
